const projectServicePrefix = /^projects service returned \d+:\s*/i;

const errorText = (value: unknown, depth = 0): string | undefined => {
    if (depth > 3 || value === null || value === undefined) return undefined;

    if (typeof value === "object") {
        const payload = value as Record<string, unknown>;
        return errorText(payload.error, depth + 1)
            ?? errorText(payload.message, depth + 1)
            ?? errorText(payload.detail, depth + 1);
    }

    if (typeof value !== "string") return undefined;
    const text = value.trim();
    if (!text) return undefined;

    const serviceBody = text.replace(projectServicePrefix, "");
    if (serviceBody !== text) {
        try {
            return errorText(JSON.parse(serviceBody), depth + 1) ?? serviceBody;
        } catch {
            return serviceBody;
        }
    }

    return text;
};

export const apiErrorMessage = (reason: unknown, fallback: string): string => {
    if (!reason || typeof reason !== "object") return fallback;
    const responseData = (reason as { response?: { data?: unknown } }).response?.data;
    return errorText(responseData) ?? fallback;
};
